module.exports = __webpack_public_path__ + "static/api-dd8bcca3a4a43d455c1f56a6aa2f6167.png";